import React  from 'react';
import NumberComponentProto from './number-proto.jsx';


export default function renderNumberInView(id, props) {
    return <NumberComponentProto renderMode="view" id={id} {...props} />;
}